import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { DiscountDAO } from '../../../../core/services/dao/discountDAO';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { AdminAccess } from '../../../shared/accessAdmin';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss'],
})
export class CouponsComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public subs: Subscription[] = [];
  public columnDefs = CouponsComponent.createColumnDefs();
  public rowData = [];
  public editPath = 'manage/admin/coupons/edit';

  constructor(
    private router: Router,
    private userDAO: UserDAO,
    private discountDAO: DiscountDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
    this.createRowData();
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private static createColumnDefs() {
    return [
      {
        headerName: 'Code',
        field: 'code',
        filter: 'text',
      },
      {
        headerName: 'Amount',
        field: 'amount',
        filter: 'number',
      },
      {
        headerName: 'active',
        field: 'active',
        filter: 'boolean',
      },
      {
        headerName: 'percentage based',
        field: 'percentageBased',
        filter: 'boolean',
      },
    ];
  }

  private createRowData() {
    const discountSub = this.discountDAO.get().subscribe((data) => {
      this.rowData = data;
    });
    this.subs.push(discountSub);
  }
}
